export default __webpack_public_path__ + "media/images/worker-image-6e1b9784b4538da8893180aa866ce16a.png";